export default {
  title: 'Alergeny',
  description: 'Należy pamiętać, że ten {{product}} może zawierać następujące składniki lub ich pochodne:',
  options: {
    dairy: 'Nabiał/Mleko',
    eggs: 'Jaja',
    fish: 'Ryby',
    gluten: 'Gluten',
    mango: 'Mango',
    peanuts: 'Orzeszki ziemne',
    sesame: 'Sezam',
    shellfish: 'Owoce morza',
    soy: 'Soja',
    tree_nuts: 'Orzechy drzewne',
    celery: 'Seler',
    crustaceans: 'Skorupiaki',
    lupin: 'Łubin',
    molluscs: 'Mięczaki',
    mustard: 'Musztarda',
    nuts: 'Orzechy',
    sulphites: 'Siarczyny',
    almonds: 'Migdały',
    barley: 'Jęczmień',
    brazil_nuts: 'Orzechy brazylijskie',
    cashew: 'Nerkowce',
    hazelnuts: 'Orzechy laskowe',
    kamut: 'Kamut',
    macadamia: 'Orzechy makadamia',
    oats: 'Owies',
    pecan: 'Pekan',
    pistachios: 'Pistacje',
    rye: 'Żyto',
    spelt: 'Orkisz',
    walnuts: 'Orzechy włoskie',
    wheat: 'Pszenica',
    sugared_drink: 'Napój słodzony',
    lentils: 'Soczewica',
    queensland_nuts: 'Orzechy Queensland',
  },
};
